export function isUnavailableGroup(group) {
	return Boolean(group && (group.quit === true || group.dissolve === true));
}

export function resolveRequestErrorMessage(error) {
	if (!error) {
		return '';
	}
	if (typeof error === 'string') {
		return error;
	}
	const responseData = error.response && error.response.data;
	if (typeof responseData === 'string') {
		return responseData;
	}
	return String(
		error.message ||
		(responseData && responseData.message) ||
		''
	).trim();
}

export function isUnavailableGroupError(error) {
	const message = resolveRequestErrorMessage(error);
	return /群聊不存在|群组不存在|您(?:已)?不在群聊中|已退出群聊|群聊已解散/.test(message);
}

export function resolveUnavailableGroupNotice(group, error) {
	if (group && group.dissolve === true) {
		return '群聊已解散，会话已从列表移除';
	}
	const message = resolveRequestErrorMessage(error);
	if (/不存在/.test(message)) {
		return '群聊不存在，会话已从列表移除';
	}
	return '您已不在该群聊，会话已从列表移除';
}
